@if (!(hideCookieBanner$ | async) && !isDekraEmployeeLoggedIn() && !cookiesAccepted && !cookiesRejected && useStandardLayout) {
	<cookies-banner></cookies-banner>
}
<div class="global-spinner-wrapper" [nbSpinner]="showGlobalSpinner$ | async" nbSpinnerSize="giant" nbSpinnerStatus="primary">
	@if (useStandardLayout) {
		<div class="main-container" [ngClass]="rolesForCss$ | async">
			<maintenance-banner [maintenanceInfo]="maintenanceInfo$ | async"></maintenance-banner>
			<div class="umbrella-header"
				 [ngClass]="{'with-cookie-banner': !(hideCookieBanner$ | async) && !isDekraEmployeeLoggedIn() && !cookiesAccepted && !cookiesRejected && !smallScreen, 'with-cookie-banner-and-small-screen': !(hideCookieBanner$ | async) && !cookiesAccepted && !cookiesRejected && smallScreen, 'hide-header': !(headerVisibilityService.isHeaderVisible() | async)}">
				<dekra-logo (click)="onDekraLogoClicked()" [currentLang]="currentLang()"></dekra-logo>
				<user-account></user-account>
			</div>
			<div class="umbrella-body">
				<router-outlet></router-outlet>
			</div>
			@if (displayVersion) {
				<app-version></app-version>
			}
			@if (showFooter$ | async) {
				<umbrella-footer></umbrella-footer>
			}
		</div>
	}
	@if (!useStandardLayout) {
		<div>
			<router-outlet></router-outlet>
		</div>
	}
</div>
